import { createFileRoute } from "@tanstack/react-router";
import { MuranoLeksikonIndexPage } from "@/pages/MuranoLeksikonPage";
import { localizedHead, SITE_URL } from "@/lib/seo";
import { leksikonArticles } from "@/lib/murano-leksikon";

const TITLE = "Murano-leksikon — vintage Murano-glas forklaret | Farveladeland";
const DESC =
  "Vores samlede viden om vintage Murano-glas: teknikker, producenter, historie og pleje. Lær Vetri, Mazzega, Seguso og sommerso at kende.";

export const Route = createFileRoute("/murano/leksikon/")({
  head: () => {
    const local = localizedHead({ path: "/murano/leksikon", locale: "da" });
    const itemListLd = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Murano-leksikon",
      itemListElement: leksikonArticles.map((a, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `${SITE_URL}/murano/leksikon/${a.slug}`,
        name: a.da.title,
      })),
    };
    return {
      meta: [
        { title: TITLE },
        { name: "description", content: DESC },
        { property: "og:title", content: TITLE },
        { property: "og:description", content: DESC },
        { property: "og:type", content: "website" },
        { property: "og:image", content: leksikonArticles[0].cover },
        ...local.meta,
      ],
      links: local.links,
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(itemListLd) },
      ],
    };
  },
  component: () => <MuranoLeksikonIndexPage locale="da" />,
});
